import AboutTimeline from "../../components/AboutTimeline";

function About() {
  return <AboutTimeline />;
}

export default About;